module.exports = __webpack_public_path__ + "img/PION_Classroom_Gray.40d6ba4d.svg";